<template>
  <v-dialog
    v-model="modalEditactualite"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Éditer une actualité</span>
      </v-card-title>
      <v-card-text v-if="modalEditactualite">
        <v-container v-show="loadingstatus">
          Édition de l’actualité en cours...
        </v-container>
        <v-container v-show="!loadingstatus">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                >
                  <v-switch
                    v-model="editactualite.publie"
                    color="primary"
                    label="Publier"/>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="editactualite.titre"
                    class="purple-input"
                    label="Titre"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editactualite.datestart"
                        label="Début de l’actualité"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="editactualite.datestart"
                      class="calendar"
                      no-title
                      @input="menu = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editactualite.dateend"
                        label="Fin de l’actualité"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="editactualite.dateend"
                      class="calendar"
                      no-title
                      @input="menu1 = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <span>Couverture actuelle</span>
                  <v-img
                    v-if="editactualite.couverture"
                    :src="editactualite.couverture"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    max-width="500"
                    max-height="150"
                  />
                  <v-file-input
                    v-model="editactualite.couverturenew"
                    placeholder="Ajouter une image de couverture"
                    label="Couverture"
                    multiple
                    prepend-icon="mdi-paperclip"
                    accept="image/*"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                        small
                        label
                        color="primary"
                      >
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-flex>
                <v-flex
                  xs12
                  md12>
                  <span>Contenu de l’actualité</span>
                  <ckeditor
                    v-model="editactualite.contenu"
                    :config="configck"
                    type="classic"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Editactualite')"
        >Annuler</v-btn
        >
        <v-btn
          color="primary darken-1"
          text
          @click="editActualite()"
        >Éditer</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { db, storage } from '@/plugins/firebase'
import moment from 'moment'

export default {
  data: () => ({
    configck: {
      language: 'fr',
      removePlugins: [ 'Heading' ],
      toolbar: [ 'bold', 'italic', 'bulletedList', 'blockQuote' ]
    },
    show: false,
    invalidlog: false,
    menu: false,
    menu1: false,
    loadingstatus: false,
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters(['modalEditactualite', 'editactualite'])
  },
  methods: {
    ...mapActions(['closeModal']),
    editActualite () {
      const $this = this
      this.loadingstatus = true
      this.editactualite.dateend = moment(this.editactualite.dateend).format('YYYY-MM-DD')
      this.editactualite.datestart = moment(this.editactualite.datestart).format('YYYY-MM-DD')
      if (moment(this.editactualite.dateend).isBefore(this.editactualite.datestart)) {
        const datebefore = this.editactualite.dateend
        this.editactualite.dateend = this.editactualite.datestart
        this.editactualite.datestart = datebefore
      }
      if (this.editactualite.couverturenew) {
        if (this.editactualite.couverturename) {
          const oldimg = storage.ref().child('images/' + this.editactualite.couverturename)
          oldimg.delete().then(function () {
            const file = $this.editactualite.couverturenew[0]
            storage.ref('images/' + file.name).put(file)
              .then(response => {
                response.ref.getDownloadURL().then(downloadURL => {
                  $this.editactualite.couverture = downloadURL
                  $this.editactualite.couverturename = file.name
                  delete $this.editactualite['couverturenew']
                  db.collection('actualites')
                    .doc($this.editactualite.id)
                    .update($this.editactualite)
                  $this.closeModal('Editactualite')
                  $this.loadingstatus = false
                }).catch(function (error) {
                  console.log(error)
                })
              }).catch(function (error) {
                console.log(error)
              })
          })
        } else {
          const file = $this.editactualite.couverturenew[0]
          storage.ref('images/' + file.name).put(file)
            .then(response => {
              response.ref.getDownloadURL().then(downloadURL => {
                $this.editactualite.couverture = downloadURL
                $this.editactualite.couverturename = file.name
                delete $this.editactualite['couverturenew']
                db.collection('actualites')
                  .doc($this.editactualite.id)
                  .update($this.editactualite)
                $this.closeModal('Editactualite')
                $this.loadingstatus = false
              }).catch(function (error) {
                console.log(error)
              })
            }).catch(function (error) {
              console.log(error)
            })
        }
      } else {
        db.collection('actualites')
          .doc(this.editactualite.id)
          .update(this.editactualite)
        this.closeModal('Editactualite')
        this.loadingstatus = false
      }
    }
  }
}
</script>
